import React, { useState, useEffect, useMemo, useRef } from 'react';

import { KTSVG } from '../../../../_metronic/helpers';
import { formatDecimal, toaster } from 'app/utilities/commons';
import TableComponent from 'app/components/TableComponent';
import { AlertComponent } from 'app/components/AlertComponent/AlertComponent';

import './styles/nomina.css';
import axios from 'axios';
import {
  getAllCoincidences,
  getAllIncidents,
} from 'app/service/c_nomina/C_Nomina';
const API_URL = process.env.REACT_APP_API_NET;

type Period = {
  id: number;
  fechaPeriodo: any;
  statusId?: any;
};

type Incident = {
  employeeCode: any;
  employeeName: string;
  employeeNumber: string;
  incidentId: number;
  status: any;
};

type Coincidence = {
  codigoEmpleado: string;
  empleado: string;
  salary: number;
  salaryAdjustment: number;
  salaryAdvance: number;
  vacationTime: number;
  totalPerceptions: number;
  totalDeductions: number;
  netPay: number;
};

const columnsIncidents = [
  { code: 'employeeNumber', label: 'Número del Empleado', textAlign: 'center' },
  { code: 'employeeCode', label: 'Código del Empleado', textAlign: 'center' },
  { code: 'employeeName', label: 'Nombre del Empleado', textAlign: 'center' },
  { code: 'status', label: 'Estatus', textAlign: 'center' },
  { code: 'description', label: 'Descripción', textAlign: 'center' },
  { code: 'acciones', label: 'Acciones', textAlign: 'center' },
];

const columnsCoincidences = [
  { code: 'codigoEmpleado', label: 'No. Empleado', textAlign: 'center' },
  { code: 'empleado', label: 'Nombre', textAlign: 'center' },
  { code: 'salary', label: 'Sueldo', textAlign: 'center' },
  { code: 'salaryAdjustment', label: 'Ajustes de Sueldo', textAlign: 'center' },
  { code: 'salaryAdvance', label: 'Anticipo de Sueldo', textAlign: 'center' },
  { code: 'vacationTime', label: 'Vacaciones a tiempo', textAlign: 'center' },
  {
    code: 'totalPerceptions',
    label: 'Total de Percepciones',
    textAlign: 'center',
  },
  {
    code: 'totalDeductions',
    label: 'Total de Deducciones',
    textAlign: 'center',
  },
  { code: 'netPay', label: 'NETO', textAlign: 'center' },
];

const View: React.FC = () => {
  const [periods, setPeriods] = useState<Period[]>([]);
  const [incidents, setIncidents] = useState<Incident[]>([]);
  const [coincidences, setCoincidences] = useState<Coincidence[]>([]);
  const [loadingGrid, setLoadingGrid] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageCoincidence, setCurrentPageCoincidence] = useState(1);

  const [pageSize, setPageSize] = useState(5);
  const [pageSizeCoincidence, setPageSizeCoincidence] = useState(5);
  const [totalRecordsIncidences, setTotalRecordsIncidences] = useState(0);
  const [totalRecordsCoincidences, setTotalRecordsCoincidences] = useState(0);
  const [isFetchIncidents, setIsFetchIncidents] = useState(false);
  const [isFetchCoincidences, setIsFetchCoincidences] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isActive, setisActive] = useState(false);
  const [loadingInfo, setLoadingInfo] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [bond, setBond] = useState<[]>([]);
  const [periodId, setPeriodId] = useState<any>();

  const [formattedDate, setFormattedDate] = useState<any>();
  const fetchPeriods = async () => {
    try {
      const res = await axios.get<{ data: { records: Period[] } }>(
        `${API_URL}Period`
      );

      const filterActivePeriods = res.data.data.records.filter(
        (period) => period.statusId === 1
      );

      setPeriodId(filterActivePeriods[0].id);

      const formatDate = (dateString: string) => {
        const [month, day, year] = dateString.split('/');
        return `${day}/${month}/${year}`;
      };
      const infor = formatDate(filterActivePeriods[0].fechaPeriodo);

      setPeriods(filterActivePeriods[0].fechaPeriodo);
      setFormattedDate(infor);
    } catch (err) {
      console.error('Error al obtener los periodos:', err);
    }
  };

  const fetchIncidents = async (page = currentPage, size = pageSize) => {
    try {
      const res = await getAllIncidents(page, size);
      if (Array.isArray(res)) {
        setIncidents([]);
        setTotalRecordsIncidences(0);
      } else {
        setIncidents(
          res.records.map((record) => ({
            ...record,
            employeeCode: record?.employeeCode ?? 'N/A',
            status: record?.status === 1 ? 'Activo' : 'Inactivo',
          }))
        );
        setTotalRecordsIncidences(res.totalRecords);
      }

      setLoadingGrid(false);
    } catch (err) {
      console.error('Error al obtener los Incidentes:', err);
    }
  };

  const fetchCoincidences = async (
    page = currentPageCoincidence,
    size = pageSizeCoincidence
  ) => {
    try {
      const res = await getAllCoincidences(page, size);
      if (res.records === undefined) {
        setCoincidences([]);
        setTotalRecordsCoincidences(res.totalRecords);
        setLoadingGrid(false);
        console.log('No hay resultados');
      } else {
        setCoincidences(
          res.records.map((record) => ({
            ...record,
            codigoEmpleado: record?.codigoEmpleado ?? 'N/A',
            empleado: record?.empleado ?? 'N/A',
          }))
        );
        setTotalRecordsCoincidences(res.totalRecords);
      }
      setLoadingGrid(false);
    } catch (err) {
      console.error('Error al obtener las Coincidencias:', err);
    }
  };

  const processSecondRoster = async (idRoster: number) => {
    try {
      setIsProcessing(true);
      getBond();
      const response = await axios.get(
        `${API_URL}LoadFirstExcel/process-second-roster?idPeriodo=${idRoster}`
      );
      // setBond([]);
      toaster.success(response.data.message);
    } catch (error) {
      console.error('Error processing the roster');
      throw error;
    } finally {
      setIsProcessing(false);
    }
  };

  const toggleStatusPayroll = async (id: number) => {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_NET}Collaborator/${id}/toggle_status_calculation_payroll`
      );
      console.log(res.data);
      toaster.success(res.data.message);
      fetchIncidents();
    } catch (err: any) {
      console.error('Error al desactivar: ', err.data.message);
    }
  };

  const handleFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();

      fileInputRef.current.onchange = async (event: Event) => {
        let input = event.target as HTMLInputElement;
        const selectedFile = input.files?.[0];

        if (selectedFile) {
          const allowedExtensions = ['.xlsx', '.xlsm'];
          const fileExtension = selectedFile.name
            .split('.')
            .pop()
            ?.toLowerCase();

          if (!allowedExtensions.includes(`.${fileExtension}`)) {
            toaster.error('Archivos validos: .xlsx, .xlsm');
            resetInput();
            return;
          }

          const formData = new FormData();
          formData.append('File', selectedFile);

          try {
            setLoading(true);
            const res = await axios.post(
              `${process.env.REACT_APP_API_NET}LoadFirstExcel/upload`,
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              }
            );
            toaster.success('El archivo se subió correctamente');

            setTimeout(() => {
              // handleFetchIncidents();
              // handleFetchCoincidences();
              fetchIncidents(currentPage, pageSize);
              fetchCoincidences(currentPage, pageSize);
              setLoadingInfo(true);
            }, 1000);
          } catch (err) {
            toaster.error('Error en el formato de archivo de carga');
          } finally {
            setLoading(false);
            resetInput();
          }
        }
      };
    }
  };

  const getBond = async () => {
    try {
      const response = await axios.get(`${API_URL}BondsDepartment`);
      setBond(response.data.data.records);
      return response.data.data;
    } catch (error) {
      return [];
    }
  };

  const resetInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  useEffect(() => {
    fetchPeriods();
    // handleFetchIncidents();

    getBond();

    setTimeout(() => {
      if (bond.length > 0) {
        handleFetchCoincidences();
        setisActive(true);
      }
    }, 1000);

  }, [bond.length]);

  useEffect(() => {
    if (isFetchIncidents) {
      fetchIncidents(currentPage, pageSize);
    }
  }, [currentPage, pageSize, isFetchIncidents]);

  useEffect(() => {
    if (isFetchCoincidences) {
      fetchCoincidences(currentPageCoincidence, pageSizeCoincidence);
    }
  }, [currentPageCoincidence, pageSizeCoincidence, isFetchCoincidences]);

  const handleFetchIncidents = () => {
    setIsFetchIncidents(true);
    fetchIncidents(1, pageSize);
  };

  const handleFetchCoincidences = () => {
    setLoadingInfo(true);
    setIsFetchCoincidences(true);
    fetchIncidents(1, pageSize);
  };

  const getDescription = (row: any) => {
    if (row.employeeNumber != null) {
      return 'No encontrado';
    }
    if (row.employeeCode != null) {
      return 'No registrado';
    }
  };

  // Show all the Incidents
  const rows = useMemo(() => {
    if (!loadingGrid && incidents.length) {
      return incidents.map((row) => ({
        employeeNumber: (
          <div style={{ textAlign: 'center' }}>
            {row.employeeNumber || 'N/A'}
          </div>
        ),
        employeeCode: (
          <div style={{ textAlign: 'center' }}>{row.employeeCode || 'N/A'}</div>
        ),
        employeeName: (
          <div style={{ textAlign: 'center' }}>{row.employeeName || 'N/A'}</div>
        ),
        description: (
          <div style={{ textAlign: 'center', color: 'red' }}>
            {getDescription(row)}
          </div>
        ),
        status: (
          <div
            style={{ textAlign: 'center' }}
            className={
              row.status === 'Activo'
                ? 'badge badge-success'
                : 'badge badge-warning'
            }
          >
            {row.status || 'N/A'}
          </div>
        ),
        acciones: (
          <div
            style={{
              textAlign: 'center',
              cursor: 'pointer',
              display: row.incidentId ? 'initial' : 'none',
            }}
          >
            <span
              className="badge badge-light"
              onClick={() => `${toggleStatusPayroll(row.incidentId)}`}
            >
              Desactivar
            </span>
          </div>
        ),
      }));
    }
    return [];
  }, [incidents, loadingGrid]);

  // Show all the Coincidences
  const rowsCoincidences = useMemo(() => {
    if (!loadingGrid && coincidences.length) {
      return coincidences.map((row) => ({
        codigoEmpleado: (
          <div style={{ textAlign: 'center' }}>{row.codigoEmpleado}</div>
        ),
        empleado: <div style={{ textAlign: 'center' }}>{row.empleado}</div>,
        salary: (
          <div style={{ textAlign: 'center' }}>${formatDecimal.format(row.salary)}</div>
        ),
        salaryAdjustment: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.salaryAdjustment)}
          </div>
        ),
        salaryAdvance: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.salaryAdvance)}
          </div>
        ),
        vacationTime: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.vacationTime)}
          </div>
        ),
        totalPerceptions: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.totalPerceptions)}
          </div>
        ),
        totalDeductions: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.totalDeductions)}
          </div>
        ),
        netPay: (
          <div style={{ textAlign: 'center' }}>
            ${formatDecimal.format(row.vacationTime)}
          </div>
        ),
      }));
    }
    return [];
  }, [coincidences, loadingGrid]);

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xxl-12 col-xl-12 col-md-12 col-lg-12">
          <div className="card card-flush p-5">
            <div className="w-100 d-flex">
              <label className="fw-bold fs-6 mb-2 w-auto">Período</label>
            </div>
            <div
              className="w-100 d-flex"
              style={{ justifyContent: 'space-between', marginBottom: '2em' }}
            >
              <input
                style={{ paddingLeft: '1em' }}
                type="text"
                disabled
                defaultValue={formattedDate}
              />
              <div className="d-flex">
                {totalRecordsIncidences !== 0 ? (
                  <button
                    type="submit"
                    className="btn btn-primary me-5"
                    title="Actualizar Información"
                    onClick={(e) => {
                      e.preventDefault();
                      toaster.success("Validando Información");
                      fetchIncidents(currentPage, pageSize);
                      fetchCoincidences(currentPage, pageSize);
                      // handleFetchIncidents();
                      // handleFetchCoincidences();
                    }}
                  >
                    <KTSVG
                      path="/media/icons/duotune/arrows/arr029.svg"
                      className="svg-icon-1 svg-icon-light svg-icon-2hx"
                    />
                  </button>
                ) : (
                  <></>
                )}

                <div>
                  <button
                    type="button"
                    className="btn btn-primary h-100"
                    onClick={handleFileUpload}
                    disabled={loading}
                    title={loading ? 'Subiendo...' : 'Subir Archivo'}
                  >
                    {loading ? 'Subiendo...' : 'Subir Archivo'}
                  </button>
                  <input
                    type="file"
                    ref={fileInputRef}
                    accept=".xlsx,.xlsm"
                    style={{ display: 'none' }}
                  />
                </div>
              </div>
            </div>
            {totalRecordsIncidences === 0 ? (
              <AlertComponent
                incidences={totalRecordsIncidences}
                coincidences={totalRecordsCoincidences}
              />
            ) : (
              <></>
            )}

            <TableComponent
              heads={columnsIncidents}
              rows={rows}
              rowsPerPage={pageSize}
              page={currentPage}
              totalRows={totalRecordsIncidences}
              setPage={setCurrentPage}
            />

            <TableComponent
              heads={columnsCoincidences}
              rows={rowsCoincidences}
              rowsPerPage={pageSizeCoincidence}
              page={currentPageCoincidence}
              totalRows={totalRecordsCoincidences}
              setPage={setCurrentPageCoincidence}
              isLoading={loadingInfo}
            />

            {totalRecordsCoincidences !== 0 && totalRecordsIncidences === 0 ? (
              <div className="d-flex flex-row-reverse ">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isActive}
                  onClick={(e) => {
                    e.preventDefault();
                    if (totalRecordsCoincidences !== 0) {
                      if (bond.length === 0) {
                        processSecondRoster(periodId);
                        setisActive(true);
                      } else {
                        toaster.warning('Este período ya fue procesado');
                      }
                    } else {
                      toaster.warning('No tiene coincidencias para procesar');
                    }
                  }}
                >
                  Procesar
                </button>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export { View };
